// Le pasamos como primera parametro un array de todos los paises disponibles, y como segundo parametro un array de los paremetros que queremos mostrar
export const getIncludeLangs = (arrayLangs, apiLangs) => {
  const flags = arrayLangs.filter((language) =>
    apiLangs.includes(language.lang)
  );

  return flags;
};
